var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2981 7.61042C2.27849 8.11708 0 10.3038 0 12.9167V20H16.3333V12.9167C16.3333 10.3038 14.0548 8.11708 11.0352 7.61042C12.3832 6.86 13.2708 5.59625 13.2708 4.16667C13.2708 1.86917 10.981 0 8.16663 0C5.3522 0 3.06248 1.86917 3.06248 4.16667C3.06248 5.59625 3.95009 6.86 5.2981 7.61042ZM9.69787 8.33333C12.7935 8.33333 15.3124 10.3896 15.3124 12.9167V19.1667H1.02083V12.9167C1.02083 10.3896 3.53972 8.33333 6.63538 8.33333H9.69787ZM8.16663 0.833333C10.4181 0.833333 12.2499 2.32875 12.2499 4.16667C12.2499 6.00458 10.4181 7.5 8.16663 7.5C5.91519 7.5 4.08331 6.00458 4.08331 4.16667C4.08331 2.32875 5.91519 0.833333 8.16663 0.833333Z",
    fill: "#FD8061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.b166b8449914db2777bb3290e5b36aaa.svg";
export { ForwardRef as ReactComponent };